/**
 * Smooth scroll-to-top that waits for layout changes to complete.
 * Uses a longer delay to let React finish rendering and avoid jitter.
 */
export const scrollToTop = () => {
  // Wait for layout changes to complete before smooth scrolling
  requestAnimationFrame(() => {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 30); // Very fast response
  });
};

/**
 * Enhanced scroll-to-top with debugging for persistent issues.
 * Use this when troubleshooting scroll problems.
 */
export const scrollToTopDebug = () => {
  console.log("🔝 Scroll triggered, current scrollY:", window.scrollY);

  // Wait for layout changes and then smooth scroll
  requestAnimationFrame(() => {
    setTimeout(() => {
      console.log(
        "⏰ Starting smooth scroll, current scrollY:",
        window.scrollY,
      );
      window.scrollTo({ top: 0, behavior: "smooth" });

      // Check if scroll completed properly
      setTimeout(() => {
        console.log("📍 After smooth scroll, scrollY:", window.scrollY);
      }, 500);
    }, 30);
  });
};

/**
 * Immediate smooth scroll for cases where layout is already stable.
 * Use this when you're confident no layout shifts will occur.
 */
export const scrollToTopImmediate = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

/**
 * Scrolls to top with an additional delay for complex layout changes.
 * Use this when multiple async operations might cause layout shifts.
 */
export const scrollToTopDelayed = (delay: number = 50) => {
  setTimeout(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, delay);
};
